import { useEffect, useMemo, useState } from 'react';
import { CustomButton, InputSelect } from 'shared_ui_components';
import classes from './QualifyingCiteriaRealplay.module.css';
import { useUpdatePassingCriteriaMutation } from 'features/settings/components/QualifyingCriteria/QualifiyingCriteria.queries';

const defaultOpt = { value: 2.5, label: '2.5' };

const QualifyingCriteriaRealplay = ({ data, isLoading }) => {
  const [roleplayCriteria, setRoleplayCriteria] = useState({ value: '', label: 'Loading...' });

  useEffect(() => {
    if (isLoading) return;
    const value = data?.roleplay?.rating_to_qualify || 2.5;
    if (value) setRoleplayCriteria({ value, label: `${value}` });
  }, [data, isLoading]);

  const options = useMemo(() => {
    const opts = [];
    let value = 0.5;
    do {
      opts.push({ value, label: `${value}` });
      value += 0.5;
    } while (value <= 2.5);
    return opts;
  }, []);

  const criterion_uuid = useMemo(() => {
    if (!data) return '';
    return data?.roleplay?.uuid;
  }, [data]);

  const onRoleplayCriteriaChange = (opt) => setRoleplayCriteria(opt);
  const resetValue = () => setRoleplayCriteria(defaultOpt);

  const { mutate } = useUpdatePassingCriteriaMutation();
  const onSubmit = () => mutate({ criterion_uuid, min_value: roleplayCriteria?.value });

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <h1>Interactive Roleplay</h1>
        <p>Rating to qualify</p>
        <InputSelect
          disabled={isLoading}
          value={roleplayCriteria}
          onChange={onRoleplayCriteriaChange}
          options={options}
        />
        <div className={classes.buttonsContainer}>
          <button type="button" onClick={resetValue} className={classes.reset}>
            Reset to default
          </button>
          <CustomButton onClick={onSubmit}>Save</CustomButton>
        </div>
      </div>
    </div>
  );
};

export default QualifyingCriteriaRealplay;
